import { uiText, useUiLanguage } from '../../../../../utils/uiTranslation';
import React from 'react';

const Sparkline = ({ points, tone = 'positive' }) => {
  if (!Array.isArray(points) || points.length < 2) return null;

  const width = 42;
  const height = 20;
  const max = Math.max(...points);
  const min = Math.min(...points);
  const range = max - min || 1;

  const path = points
    .map((point, index) => {
      const x = (index / (points.length - 1)) * width;
      const y = height - ((point - min) / range) * (height - 2) - 1;
      return `${index === 0 ? 'M' : 'L'} ${x.toFixed(1)} ${y.toFixed(1)}`;
    })
    .join(' ');

  return (
    <svg className={`executive-overview-sparkline ${tone}`} viewBox={`0 0 ${width} ${height}`} aria-hidden="true">
      <path d={path} fill="none" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
};

const splitKpiValue = (value) => {
  const source = String(value || '').trim();
  const match = source.match(/^([\d./%]+)\s*(.*)$/);

  if (!match) {
    return { primary: source, unit: '' };
  }

  return {
    primary: match[1] || source,
    unit: (match[2] || '').trim()
  };
};

const ExecutiveKpiBar = ({ kpis, isRTL = false }) => { useUiLanguage(); return (<article className="executive-overview-panel executive-overview-kpis">
    <div className="executive-overview-kpi-grid">
      {kpis.length ? kpis.map((item) => {
        const { primary, unit } = splitKpiValue(item.value);

        return (
          <div key={item.label} className="executive-overview-kpi">
            <span className="executive-overview-kpi-label">{uiText(item.label)}</span>
            <strong className="executive-overview-kpi-value">
              <span className="executive-overview-kpi-value-main">{primary}</span>
              {unit ? <span className="executive-overview-kpi-value-unit">{unit}</span> : null}
            </strong>
            <div className="executive-overview-kpi-footer">
              <span className={`executive-overview-kpi-sub ${item.accent}`}>{item.sublabel}</span>
              <Sparkline points={item.trend} tone={item.accent} />
            </div>
          </div>
        );
      }) : (
        <div className="executive-overview-empty-state">
          {isRTL ? 'لا توجد بيانات تحليلية مباشرة متاحة بعد.' : 'No live analytics data is available yet.'}
        </div>
      )}
    </div>
  </article>); };

export default ExecutiveKpiBar;
